/* eslint-disable import/prefer-default-export */
export const HANDICAP_TYPE = {
  moteur: 'Personne touchée par une incapacité à marcher',
  psychique:
    'Personne touchée par des difficultés de la compréhension, de la communication et de la décision',
  'mal-entendant': 'Personne touchée par une surdité totale',
  'mal-voyant': 'Personne touchée par une cécité totale',
  'mal-voyant-partiel':
    'Personne touchée par une déficience visuelle partielle',
  'mal-entendant-partiel':
    'Personne touchée par une déficience auditive partielle',
  'femme-enceinte':
    'Personne ayant un trouble de la mobilité dû à une situation handicapante temporaire (ex: poussette ou valise)',
  senior: 'Personne éprouvant des difficultés à marcher',
}

export const ACCESSIBILITY_LEVEL = {
  2: 'Accessible en autonomie',
  1: 'Accessible avec accompagnement ou partiellement',
  0: 'Inaccessible',
  '-2': "Niveau d'accessibilité Non défini",
}
